// Seletor de célula do coletor: células ativas reais, as deste tablet primeiro (UAT 2026-10-06).
import type { ReactElement } from 'react';
import { rotuloCelula, type OpcoesCelulaColetor } from '../../lib/coletor/celulas-coletor';

export interface SeletorCelulaColetorProps {
  readonly opcoes: OpcoesCelulaColetor;
  readonly valor: string | null;
  readonly onAlterar: (codigo: string) => void;
}

export function SeletorCelulaColetor({ opcoes, valor, onAlterar }: SeletorCelulaColetorProps): ReactElement {
  const { vinculadas, outras } = opcoes;
  const agrupar = vinculadas.length > 0 && outras.length > 0;
  const itens = (lista: OpcoesCelulaColetor['outras']) =>
    lista.map((celula) => <option key={celula.codigo} value={celula.codigo}>{rotuloCelula(celula)}</option>);
  return (
    <select
      id="coletor-celula"
      value={valor ?? ''}
      disabled={vinculadas.length + outras.length === 0}
      onChange={(e) => onAlterar(e.target.value)}
      className="min-h-[48px] min-w-0 max-w-full px-3 py-2 bg-slate-950 border border-slate-700 rounded-lg text-sm text-white focus:ring-2 focus:ring-emerald-400 disabled:opacity-50"
    >
      {vinculadas.length + outras.length === 0 && <option value="">Nenhuma célula ativa</option>}
      {agrupar ? (
        <>
          <optgroup label="Células deste tablet">{itens(vinculadas)}</optgroup>
          <optgroup label="Outras células ativas">{itens(outras)}</optgroup>
        </>
      ) : (
        itens([...vinculadas, ...outras])
      )}
    </select>
  );
}
